import React from 'react';
// import React from 'react-native-elements';
import {useMutation} from "@apollo/client";
import {ASSIGN_WORKSHOP_AND_ADVISOR, REASSIGN_WORKSHOP_AND_ADVISOR} from "../query";
import {clientV2} from "../../../common";
import {View, Text} from "react-native";

interface IReassignWorkshopAndAdvisorMutationProps {
    children: ({
                   reassignWorkshopAndAdvisorMutation
               }) => JSX.Element;
}

export const ReassignWorkshopAndAdvisorMutation = (props: IReassignWorkshopAndAdvisorMutationProps) => {
    const [reassignWorkshopAndAdvisorMutation, {data}] = useMutation(REASSIGN_WORKSHOP_AND_ADVISOR, {client: clientV2});
    return props.children({reassignWorkshopAndAdvisorMutation})
};